/**
 * 水平拖拽
 */
import fvAnimation from './fvAnimation';

export default class fvHorDrag extends fvAnimation {
    constructor(shape) {
        super(shape, 'fvHorDrag');
        this.dragingFlag = 0;
        this.orgShapePt = {
            x: 0,
            y: 0
        };
        this.min = AsyncFunction('return ' + this.min);
        this.max = AsyncFunction('return ' + this.max);
        this.minMoveToValue = AsyncFunction('return ' + this.minMoveToValue);
        this.maxMoveToValue = AsyncFunction('return ' + this.maxMoveToValue);
        this.orgShapePt.x = this.shape.x;
    }

    async run(event, show, domObj) {
        //判断如果是数据库变量， 就不执行
        if(this.fvScript.system.$.dbCom.isDbVar(this.expression)) return;
        var minValue = await this.executionScript(this.min);
        var maxValue = await this.executionScript(this.max);
        var minMoveToValueValue = await this.executionScript(this.minMoveToValue);
        var maxMoveToValueValue = await this.executionScript(this.maxMoveToValue);
        var X = event.offsetX - parseFloat(domObj.style.height) / 2;
        let value_X;
        if(minValue < maxValue) {
            value_X = this.orgShapePt.x - X;
            if(-value_X < minValue) {
                value_X = minValue;
            } else if(-value_X > maxValue) {
                value_X = maxValue;
            }
        } else if(minValue > maxValue) {
            value_X = this.orgShapePt.x + parseFloat(minValue) - X;
            if(value_X > minValue) {
                value_X = minValue;
            } else if(value_X < maxValue) {
                value_X = maxValue;
            }
        }
        Function(`${this.expression}='${Math.abs(value_X)}'`)();
    }

}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvHorDrag.js